import { Badge } from "@chakra-ui/react"

export const ClientCurrentStatus = ({customer}) => {
    return (
        <>
            {customer.has_error && <Badge colorScheme='red'>Plaid link issue</Badge>}
        </>
    )
}
